import { render, staticRenderFns } from "./commitmentSign.vue?vue&type=template&id=ffa17f58&scoped=true"
import script from "./commitmentSign.vue?vue&type=script&lang=js"
export * from "./commitmentSign.vue?vue&type=script&lang=js"
import style0 from "./commitmentSign.vue?vue&type=style&index=0&id=ffa17f58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa17f58",
  null
  
)

export default component.exports